export interface ApprovedUsedBannerProps {
  variant: 'serps' | 'product';
  saving?: number;
}

const ApprovedUsedBanner = ({ saving, variant }: ApprovedUsedBannerProps) => {
  const BannerCopy = ({ saving, variant }: ApprovedUsedBannerProps) => {
    if (variant === 'product' && saving)
      return (
        <>
          Save <span className="ch-color--ac-yellow">£{saving}</span> on this
          car today.
        </>
      );

    return <>The Approved Used Event is now on.</>;
  };

  return (
    <div className="ac-promo ac-promo--approved-used">
      <div className="ac-promo__heading">
        <p className="ac-promo__title ch-mb--0 ch-text--uppercase ch-fs--4 md:ch-fs--5 ch-fw--800">
          <BannerCopy saving={saving} variant={variant} />
        </p>
      </div>
    </div>
  );
};

export default ApprovedUsedBanner;
